import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  journeys,
  noItemToPayError,
  pieceCheckInBaggagePolicies,
  seatmap,
  weightCheckInBaggagePolicies,
} from '../../mock/data';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

/**
 * OW 1Journey
 * 1ADT
 * Display baggage allowance
 */
export const ow1Journey1AdtBaggageAllowanceRetrieve: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [
    createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items),
    createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items),
    createMockData(combineCheckInBaggagePolicies([pieceCheckInBaggagePolicies]).items),
    createMockData(combineCheckInBaggagePolicies([pieceCheckInBaggagePolicies]).items),
    createMockData(combineCheckInBaggagePolicies([weightCheckInBaggagePolicies]).items),
    createMockData(combineCheckInBaggagePolicies([weightCheckInBaggagePolicies]).items)
  ],
  getJourneyUnpaidItems: [
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError])
  ],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
